import React from "react";
import { useParams } from "react-router-dom";
import { ProfileCard } from "../../../../components/cards/ProfileCardApplicant";
import ProfileTabs from "../ProfileTabs";
import Education from "../../../applicant/Onboarding/Education/Education";

export default function EducationInfo() {
  const { id } = useParams();

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12 mt-5">
          <div className="main_contents_div">
            <ProfileCard id={id} />
            <ProfileTabs />
            <Education />
          </div>
        </div>
      </div>
    </div>
  );
}
